export default class SharedPortfolioCtrl {  
  constructor ($scope, $location,$stateParams, $timeout, PortfolioSrv, PortfolioModalSrv, GlobalConfig, $cookies, $state, GlobalSrv) {
  // constants
    var sharedPortfolioVm = this

    sharedPortfolioVm.userId = JSON.parse($cookies.get('currentUser')).id
    sharedPortfolioVm.userName = JSON.parse($cookies.get('currentUser')).name
    sharedPortfolioVm.dsFullname = JSON.parse($cookies.get('currentUser')).dsFullname
    const ownerPortfolio = {
      userId : sharedPortfolioVm.userId
    }
    const msgInvalids = [
      'Debe seleccionar un usuario de la lista',
      'No puede seleccionar usuarios repetidos'
    ]  

  //variables
    sharedPortfolioVm.usersWithSharedPermission = []
    sharedPortfolioVm.arrayOfUsers = []
    sharedPortfolioVm.selectedSharedUser = null
    sharedPortfolioVm.searchText = ''
    sharedPortfolioVm.invalidText = false
    sharedPortfolioVm.msgInvalidText = msgInvalids[0]
    sharedPortfolioVm.sharedLink = $location.absUrl().replace('sharedPortfolio','public?ownerPortfolio='+sharedPortfolioVm.userId+'&external')
    sharedPortfolioVm.disableButton = false

  //methods
    sharedPortfolioVm.searchUsers       = searchUsers
    sharedPortfolioVm.setUser           = setUser
    sharedPortfolioVm.validateForm      = validateForm
    sharedPortfolioVm.changeSharedUser  = changeSharedUser
    sharedPortfolioVm.cleanForm         = cleanForm
    sharedPortfolioVm.addSharedUsers    = addSharedUsers
    sharedPortfolioVm.showConfirmDialog = showConfirmDialog

    activate()

    function activate () {
      getSharedPortfolioUsers()
    }

    function getSharedPortfolioUsers(){
    	PortfolioSrv.getSharedPortfolioUsers.get(ownerPortfolio).$promise.then(function (dataReturn) {
	      if (dataReturn.status) {
	        sharedPortfolioVm.usersWithSharedPermission = dataReturn.usersWithSharedPermission
          sharedPortfolioVm.usersToShared = dataReturn.usersToShared
	      }
		  }, function (data) {
		      console.log(data)
		    }
	    )
    }

    function searchUsers(searchText) {
      let matcher = new RegExp(searchText,'i')
      let arr = []
      let attr = "ds_fullname"
      sharedPortfolioVm.usersToShared.forEach((list) => {
        if (list[attr].match(matcher) ) {
          arr.push(list)        
        }        
      })
      return arr
    }

    function changeSharedUser(){
      sharedPortfolioVm.invalidText = false
    }

    function setUser(){
      if (sharedPortfolioVm.selectedSharedUser){
        var index = getIndex(sharedPortfolioVm.selectedSharedUser)
        if (index < 0){
          sharedPortfolioVm.arrayOfUsers.push(sharedPortfolioVm.selectedSharedUser)        
          sharedPortfolioVm.selectedSharedUser = null
          sharedPortfolioVm.searchText = ''
          sharedPortfolioVm.invalidText = false
          sharedPortfolioVm.msgInvalidText = msgInvalids[0]
        } else {
          sharedPortfolioVm.invalidText = true
          sharedPortfolioVm.msgInvalidText = msgInvalids[1]
        } 
        
      } else {
        sharedPortfolioVm.invalidText = true
      }
    }

    function getIndex(user){
      for (var i = sharedPortfolioVm.arrayOfUsers.length - 1; i >= 0; i--) {
        if (sharedPortfolioVm.arrayOfUsers[i].id_code == user.id_code){
          return i
        }
      }
      return -1      
    }

    function getNotify(idUser,name){
      getSendNotify(idUser,name)
    }

    function getSendNotify(idUser,name){
       let postEmail = {
                idUser: idUser,
                dsName: 'Notificación de portafolio compartido',
                dsDescription: 'El profesor ' + name + ' ha compartido su portafolio con usted',
                idNotification_delivery_type: GlobalConfig.notificationType.email,
                is_grouped: 0
      }
      let postInbox = {
                idUser: idUser,
                dsName: 'Notificación de portafolio compartido',
                dsDescription: 'El profesor ' + name + ' ha compartido su portafolio con usted',
                idNotification_delivery_type: GlobalConfig.notificationType.inbox,
                is_grouped: 0
      }
      GlobalSrv.sendNotification(postEmail)
      GlobalSrv.sendNotification(postInbox)
    }

    function addSharedUsers(){
      sharedPortfolioVm.disableButton = true
      let header = {
        idOwner    : ownerPortfolio.userId,
        usersArray : sharedPortfolioVm.arrayOfUsers
      }
      PortfolioSrv.addSharedUsers.add(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          for(var i=0; i<sharedPortfolioVm.arrayOfUsers.length; i++)
          {
            getNotify(sharedPortfolioVm.arrayOfUsers[i].id_code, sharedPortfolioVm.dsFullname)
          }
          cleanForm()
          activate() 
        }
        sharedPortfolioVm.disableButton = false
      }, function (data) {
          console.log(data)
      })
    }  

  //forms    
    function validateForm () {
      return sharedPortfolioVm.searchText == '' || sharedPortfolioVm.invalidText
    }
    
    function cleanForm(){
      sharedPortfolioVm.selectedSharedUser = null
      sharedPortfolioVm.searchText = ''
      sharedPortfolioVm.invalidText = false
      sharedPortfolioVm.arrayOfUsers = []
    }

  //modals
    function showConfirmDialog(user){
      let header = {
        idOwner : ownerPortfolio.userId,
        user    : user
      }
      PortfolioModalSrv.setVariable(header)
      PortfolioModalSrv.confirmDialog().then((promise) => {   
        let shared = PortfolioModalSrv.getVariable()
        if (shared.status){
          cleanForm()
          activate()
        }     
      })
    }

  }
}

SharedPortfolioCtrl.$inject = ['$scope', '$location','$stateParams', '$timeout', 'PortfolioSrv', 'PortfolioModalSrv','GlobalConfig', '$cookies', '$state', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/sharedPortfolio/sharedPortfolioCtrl.js